import { useTranslation } from "react-i18next";

export function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();

  const setLang = (lng) => {
    if (lng !== i18n.language) i18n.changeLanguage(lng);
  };

  return (
    <div data-testid="language-switcher" className={`flex border border-border text-xs font-mono-tag ${className}`}>
      <button
        data-testid="language-switcher-zh"
        onClick={() => setLang("zh")}
        className={`px-2 py-1 transition-colors ${i18n.language === "zh" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary"}`}
      >
        中文
      </button>
      <button
        data-testid="language-switcher-en"
        onClick={() => setLang("en")}
        className={`px-2 py-1 transition-colors border-l border-border ${i18n.language === "en" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary"}`}
      >
        EN
      </button>
    </div>
  );
}
